export const api = {
  GET_LIST_BY_SHARED: '/inspections/getListByShared',
  GET_SHUMA_BASIC_DATA: '/inspections/getShumaBasicData',
};
